import React, { useState, useEffect } from 'react';
import Modalform from './Modalform';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';

function Header2() {
  const location = useLocation() || { pathname: '/blog/india' };

  // --- Colorlib-style mobile toggle: body.offcanvas ---
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const openMobile = () => {
    document.body.classList.add('offcanvas');
    setIsMobileOpen(true);
  };
  const closeMobile = () => {
    document.body.classList.remove('offcanvas');
    setIsMobileOpen(false);
  };
  const toggleMobile = (e) => {
    if (e) e.preventDefault();
    if (isMobileOpen) closeMobile();
    else openMobile();
  };

  // Close menu on route change
  useEffect(() => {
    closeMobile();
    // cleanup on unmount too
    return () => document.body.classList.remove('offcanvas');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // ESC to close
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') closeMobile(); };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, []);

  const pagesWithDefaultIndia = [
    'terms-conditions','disclaimer','privacy-policy','refund-policy',
    'site-map','Thankyou','marketarea/india','marketarea/1','marketarea/2',
    'marketarea/3','marketarea/4','marketarea/5','marketarea/6','marketarea/7'
  ];

  const currentLocation = pagesWithDefaultIndia.some(page => location.pathname.includes(`/${page}`))
    ? 'india'
    : (location.pathname.split('/')[2] || 'india');

  const [showModal, setShowModal] = useState(false);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [expanded, setExpanded] = useState(false);
  const handleNavLinkClick = () => setExpanded(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('https://phpstack-1434504-6130285.cloudwaysapps.com/api/categories?populate=*');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();

        // Normalize flat/attributes
        const items = Array.isArray(json?.data)
          ? json.data.map(item => {
              const id = item?.id ?? item?.attributes?.id;
              const name = item?.name || item?.attributes?.name || `Category ${id}`;
              const slug = item?.slug || item?.attributes?.slug || '';
              return { id, name, slug };
            })
          : [];

        setCats(items);
      } catch (e) {
        setErr(e.message || 'Failed to load categories');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // Active category for /blog/:country/:slug
  const pathParts = location.pathname.split('/').filter(Boolean);
  const activeCategorySlug = pathParts[2] || '';

  return (
    <>
      {/* Top bar on mobile (burger + logo) */}
      <nav style={{background: " #000000ff"}} className="navbar navbar-expand-lg navbar-light  desktop d-block d-md-none">
        <a
          href="#"
          className="navbar-brand js-colorlib-nav-toggle colorlib-nav-toggle"
          onClick={toggleMobile}
          aria-label="Toggle navigation"
          aria-expanded={isMobileOpen}

          style={{
           
    background:" #f8f9fa",
    padding: "11px 19px 19px",
    borderRadius: "50px",
    marginTop: "11px",
    marginRight: "30px"

          }}
        >
          <i></i>
        </a>
        <a
          className=""
          href="https://www.picanoindia.com/blog/"
          onClick={(e) => e.preventDefault()}
          aria-label="Logo"
        >
          <img style={{padding: "13px 10px 13px 0px", width:"226px"}} src="https://www.picanoindia.com/blog/img/logo.png" alt="Logo" />
        </a>
      </nav>

      {/* Aside Menu — keep original classes; Colorlib CSS will handle slide via body.offcanvas */}
      <aside id="colorlib-aside" role="complementary" className="js-fullheight">
        <nav id="colorlib-main-menu" className='sidebar hide-scrollbar' role="navigation" style={{ overflowY: "scroll",    height: "425px"}}>
          <ul>
            <li className="colorlib-active">
              <Link to={`/blog/${currentLocation}`} onClick={closeMobile}>Home</Link>
            </li>

            {/* Dynamic Categories from API */}
            {loading && <li><a href="#">Loading...</a></li>}
            {err && <li><a href="#">Error: {err}</a></li>}

            {!loading && !err && cats.map(({ id, name, slug }) => {
              const isActive = activeCategorySlug === slug;
              return (
                <li key={id} className={isActive ? 'colorlib-active' : ''}>
                  <Link to={`/blog/${currentLocation}/${slug}`} onClick={closeMobile}>
                    {name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Footer */}
        <div className="colorlib-footer">
          <a href="https://www.picanoindia.com/" style={{ backgroundImage: "url()" }}>
            <img style={{    width: "70%"}} src="https://www.picanoindia.com/blog/img/logo.png" alt="Footer Logo" />
          </a>
          <p className="pfooter mt-3 text-white">
            © ALL RIGHTS RESERVED BY <b><a className='text-white' href="https://www.picanoindia.com/">PICANO INDIA</a></b> 2026. |
            Powered by <b><a className='text-white' href="https://digics.in/">digics.in</a></b>
          </p>
        </div>
      </aside>

      {/* Mobile overlay (click to close) */}
      <div
        onClick={closeMobile}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.35)',
          backdropFilter: 'blur(1px)',
          zIndex: 998,
          display: isMobileOpen ? 'block' : 'none'
        }}
      />
    </>
  );
}

export default Header2;
